export function destroyCommon(){
    UserHelper.clear();
    LabelHelper.clear();
}
export function instantiateReportClientComponent (target) {
    $('#' + target).html('<div id="reportclient_container_vuejs_manage"><reportclient-component></reportclient-component></div>');

    let reportClientVM = new Vue({
        el: '#reportclient_container_vuejs_manage',
        components: {
            'reportclient-component': () => import('../client/kiss/reportclient/reportclient-component.vue')
        }
    })
    window.reportClientVM =reportClientVM;
}

export function destroyReportClientComponent () {
    window.reportClientVM.$destroy();
    destroyCommon();
}

export function instantiateUserDetailsComponent (target) {
    $('#' + target).html('<div id="menu_container_vuejs_manage"><menu-component></menu-component></div>');

    let userDetailsVM = new Vue({
        el: '#menu_container_vuejs_manage',
        components: {
            'menu-component': () => import('../client/kiss/userdetail/menu-component.vue')
        }
    });
    window.userDetailsVM = userDetailsVM;
}

export function destroyUserDetailsComponent () {
    window.userDetailsVM.$destroy();
    destroyCommon();
}

export function instantiateLoginComponent (target, optionalClientKey) {

    $('#' + target).html('<div id="login_container_vuejs_manage" ><home-component></home-component></div>');

    let finalClientKey = 'kiss';

    if(optionalClientKey)
        finalClientKey = optionalClientKey

    let userLoginVM = new Vue({
        el: '#login_container_vuejs_manage',
        components: {
            'home-component': () => import('../client/' + finalClientKey + '/home/home-component.vue')
        }
    });
    window.userLoginVM = userLoginVM;

}
export function destroyLoginComponent () {
    window.userLoginVM.$destroy();
    destroyCommon();
}
export function instantiateConfirmdisableComponent (target, optionalClientKey) {

    $('#' + target).html('<div id="confirmdisable_container_vuejs_manage" ><confirmdisable-component></confirmdisable-component></div>');

    let finalClientKey = 'kiss';

    if(optionalClientKey)
        finalClientKey = optionalClientKey

    let userConfirmDisableVM = new Vue({
        el: '#confirmdisable_container_vuejs_manage',
        components: {
            'confirmdisable-component': () => import('../client/' + finalClientKey + '/confirmdisable/confirmdisable-component.vue')
        }
    });
    window.userConfirmDisableVM = userConfirmDisableVM;

}
export function destroyConfirmdisableComponent () {
    window.userConfirmDisableVM.$destroy();
    destroyCommon();
}
export function instantiateSharedownloadComponent (target, optionalClientKey) {

    $('#' + target).html('<div id="sharedownload_container_vuejs_manage"' +
        ' ><sharedownload-component></sharedownload-component></div>');

    let finalClientKey = 'kiss';

    if(optionalClientKey)
        finalClientKey = optionalClientKey

    let userShareDownloadVM = new Vue({
        el: '#sharedownload_container_vuejs_manage',
        components: {
            'sharedownload-component': () => import('../client/' + finalClientKey + '/sharedownload/sharedownload-component.vue')
        }
    });
    window.userShareDownloadVM = userShareDownloadVM;

}
export function destroySharedownloadComponent () {
    window.userShareDownloadVM.$destroy();
    destroyCommon();
}



export function instantiateArkeviaRegisterComponent (target) {

    $('#' + target).html('<div id="register_container_vuejs_manage"><register-component></register-component></div>');

    let userRegisterVM = new Vue({
        el: '#register_container_vuejs_manage',
        components: {
            'register-component': () => import('../client/arkevia/register/register-component.vue')
        }
    });
    window.userRegisterVM = userRegisterVM;

}

export function destroyArkeviaRegisterComponent () {
    window.userRegisterVM.$destroy();
    destroyCommon();
}
/*window.instantiateMigrationWelcomeComponent=ModuleRepository.instantiateMigrationWelcomeComponent;
window.destroyMigrationWelcomeComponent=ModuleRepository.destroyMigrationWelcomeComponent;*/

export function instantiateMigrationWelcomeComponent (target, optionalClientKey) {

    $('#'+target).html('<div id="migration_welcome_container_vuejs_manage" ><migration-welcome-component></migration-welcome-component></div>');

    let finalClientKey = 'kiss';

    if(optionalClientKey)
        finalClientKey = optionalClientKey;

    let migrationWelcomeVM = new Vue({
        el: '#migration_welcome_container_vuejs_manage',
        components: {
            'migration-welcome-component': () => import('../client/' + finalClientKey + '/migration/migration-welcome-component.vue')
        }
    });
    window.migrationWelcomeVM = migrationWelcomeVM;

}

export function destroyMigrationWelcomeComponent () {
    window.migrationWelcomeVM.$destroy();
    destroyCommon();
}
export function instantiateBottomDetailsComponent (target) {

    $('#'+target).html('<div id="bottomdetails_container_vuejs_manage" ><bottomdetail-component></bottomdetail-component></div>');

    let finalClientKey = 'kiss';

    /*if(optionalClientKey)
        finalClientKey = optionalClientKey*/

    let bottomDetailsVM = new Vue({
        el: '#bottomdetails_container_vuejs_manage',
        components: {
            'bottomdetail-component': () => import('../client/' + finalClientKey + '/bottomdetail/bottomdetail-component.vue')
        }
    });
    window.bottomDetailsVM = bottomDetailsVM;

}

export function destroyBottomDetailsComponent () {
    window.bottomDetailsVM.$destroy();
    destroyCommon();
}

export function instantiateArkeviaUserAccountComponent (target) {

    $('#' + target).html('<div id="useraccount_container_vuejs_manage"><user-account-component></user-account-component></div>');

    let userAccountVM = new Vue({
        el: '#useraccount_container_vuejs_manage',
        components: {
            'user-account-component': () => import('../client/arkevia/useraccount/useraccount-component.vue')
        }
    });
    window.userAccountVM = userAccountVM;

}

export function destroyArkeviaUserAccountComponent () {
    window.userAccountVM.$destroy();
    destroyCommon();
}



// WEBPACK FOOTER //
// ./portal/src/moduleRepository.js